import './TestInhabitants.scss';
import template from './TestInhabitants.vhtml';

export default {
	name: 'TestInhabitants',
	template: template,
	props: {
		number: {
			type: String,
		},
		text: {
			type: String,
		},
		link: {
			type: Object,
		},
	},
	data: () => ({
		visible: false,
	}),
	mounted() {
		setTimeout(() => this.visible = true, 500);
	},
};
